<script lang="ts">
    import type { SocialProof } from '@shared/types/types';

    interface Props {
        socialProof: SocialProof;
    }

    let { socialProof }: Props = $props();
</script>

{#snippet proof(text: string)}
    <oc-tag-v1
        variant="custom-color-soft"
        size={'25'}
        style="--background-color: var(--oc-base-color-beige-100); --text-color: var(--oc-base-color-beige-140)"
    >
        {text}
    </oc-tag-v1>
{/snippet}

{#if socialProof.popular || socialProof.shortage}
    <div class="reptile-social-proof-badges">
        {#if socialProof.popular}
            {@render proof('Sehr beliebt')}
        {/if}
        {#if socialProof.shortage}
            {@render proof('Fast ausverkauft')}
        {/if}
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-social-proof-badges {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-25;
        margin-right: 10px;
        margin-bottom: tokens.$oc-semantic-spacing-25;
        margin-left: 10px;
    }
</style>
